import { useMutation, useQuery } from '@tanstack/react-query'
import {
  fetchProductByCategory,
  fetchProductById,
  fetchProducts,
  fetchProductsByList,
  fetchProductsByParams,
  fetchProductsPlacement,
  fetchSimilarProducts,
} from '@/api/product'
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams'
import { ApiResponse, Product } from '@/types/api'
import useSWR from 'swr'

export const useProducts = () => {
  return useQuery({
    queryKey: ['products'],
    queryFn: fetchProducts,
  })
}

export const useProductsByList = (sku_list: string[]) => {
  return useQuery({
    queryKey: ['product-list', sku_list],
    queryFn: () => fetchProductsByList({ sku_list }),
  })
}

export const useProduct = (id: number) => {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => fetchProductById(id),
    enabled: !!id,
  })
}

export const useProductsPost = () => {
  return useMutation({
    mutationFn: fetchProductsByParams,
  })
}
const fetcher = (params: FetchProductParams) => fetchProductsByParams(params)

export const useProductsByParam = (params: FetchProductParams, enabled=true) => {
  const { data, error, isLoading, mutate } = useSWR<ApiResponse<Product[]>>(
    ['products', params], // key
    () => fetcher(params),
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    }
  )
  console.log(data)

  return {
    products: data?.data || [],
    isLoading,
    pagination:data?.pagination,
    isError: !!error,
    mutate,
  }
}

export const useSimilarProduct = (id: number) => {
  // const queryClient = useQueryClient();

  // queryClient.invalidateQueries({ queryKey: ["product-similar"] });
  return useQuery({
    queryKey: ['product-similar', id],
    queryFn: () => fetchSimilarProducts(id),
    enabled: !!id,
  })
}

export const useProductsPlacement = (displayPage: string) => {
  return useQuery({
    queryKey: ['product-placement', displayPage],
    queryFn: () => fetchProductsPlacement(displayPage),
    enabled: !!displayPage,
  })
}

export const useProductsBySubCategory = (query: string) => {
  return useQuery({
    queryKey: ['product', query],
    queryFn: () => fetchProductByCategory(query),
    enabled: !!query,
  })
}
